<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      class="fill"
      d="M12.7768 9.48788C12.4889 10.1253 12.3512 10.4103 11.9815 10.9735C11.465 11.7601 10.7356 12.7417 9.83397 12.7485C9.03194 12.7552 8.82494 12.2252 7.73647 12.2338C6.64801 12.2391 6.42127 12.7581 5.61828 12.7499C4.7166 12.7417 4.02626 11.8574 3.50923 11.0722C2.06356 8.86976 1.91096 6.28845 2.80445 4.91499C3.43654 3.9411 4.4369 3.36919 5.37613 3.36919C6.33269 3.36919 6.93397 3.89489 7.72492 3.89489C8.49228 3.89489 8.95973 3.36775 10.066 3.36775C10.9027 3.36775 11.7875 3.82364 12.4196 4.61026C10.3515 5.74349 10.6875 8.69741 12.7768 9.48788ZM9.22643 2.4887C9.62889 1.97215 9.9341 1.24329 9.82338 0.5C9.16674 0.544771 8.39889 0.964077 7.95022 1.50711C7.54391 2.00151 7.20692 2.73614 7.33835 3.4467C8.05468 3.46981 8.79605 3.0428 9.22643 2.4887Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AppleIcon",
});
</script>

<style scoped lang="scss">
@use "../icon.scss";
</style>
